// extracted by mini-css-extract-plugin
export var wordContainer = "_qu-0";